<template>
<section class="feature-columns container-padded">
  <article v-for="feature in features" class="feature-item">
    <figure class="feature-image">
      <img :src="feature.image" alt="">
    </figure>
    <h3 class="feature-title" v-html="feature.title"></h3>
    <p v-html="feature.content"></p>
  </article>
</section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      features: 'settings/homeFeatures',
    }),
  },
}
</script>

<style lang="less">
.feature-columns {
  @apply flex flex-wrap;

  .feature-image {
    img {
      @apply inline;
      max-height: 60px;
    }
  }

  .feature-item {
    @apply w-full text-center mb-8;

    figure {
      @apply mb-4;
    }

    .feature-title {
      @apply mb-2 text-lg text-primary font-bold;
    }

    p {
      @apply text-base font-light opacity-60;
    }
  }
}

@screen md {
  .feature-columns {
    .feature-item {
      @apply w-1/2;
    }
  }
}

@screen lg {
  .feature-columns {
    .feature-item {
      @apply w-1/4 mb-0;
    }
  }
}
</style>
